export default [
  {
    id: 1,
    pathname: "/",
  },
  {
    id: 2,
    pathname: "/preinternal",
  },
  {
    id: 3,
    pathname: "/support",
  },
  {
    id: 4,
    pathname: "/preexternal",
  },
  {
    id: 5,
    pathname: "/prewallet",
  },
  {
    id: 6,
    pathname: "/prepeyk",
  },
  {
    id: 7,
    pathname: "/prebox",
  },
  {
    id: 8,
    pathname: "/preapplication",
  },
  {
    id: 9,
    pathname: "/about",
  },
  {
    id: 10,
    pathname: "/preagent",
  },
  {
    id: 12,
    pathname: "/preshop",
  },
  {
    id: 13,
    pathname: "/bulkOrder",
  },
  {
    id: 14,
    pathname: "/payinplace",
  },
  {
    id: 15,
    pathname: "/doortodoor",
  },
  {
    id: 16,
    pathname: "/expresspost",
  },
  {
    id: 17,
    pathname: "/callOrder",
  },
  {
    id: 18,
    pathname: "/onlinePayment",
  },
  {
    id: 20,
    pathname: "/beforRent",
  },
  {
    id: 21,
    pathname: "/myletters",
  },
  {
    id: 23,
    pathname: "/guide",
  },
  {
    id: 24,
    pathname: "/rules",
  },
  {
    id: 26,
    pathname: "/contact",
  },
  {
    id: 27,
    pathname: "/messages",
  },
  {
    id: 28,
    pathname: "/my-external-letters",
  },
  {
    id: 29,
    pathname: "/agent-list",
  },
  {
    id: 30,
    pathname: "/city-inquiry",
  },
  {
    id: 31,
    pathname: "/developers",
  },
  {
    id: 32,
    pathname: "/developers/web-service",
  },
  {
    id: 33,
    pathname: "/developers/plugin",
  },
  {
    id: 34,
    pathname: "/developers/digi-extension",
  },
  {
    id: 35,
    pathname: "/developers/php-package",
  },
  {
    id: 36,
    pathname: "/tracking",
  },
  {
    id: 37,
    pathname: "/privacy-policy",
  },
];
